const priceFormat = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
});

export default priceFormat;
